export const PERMISSIONS_STORAGE_KEY = "besarawak_department_permissions_v1";
export const PERMISSION_ROLES = ["Head of Department", "Head of Unit", "Staff"];
export const PERMISSION_MODULES = ["Dashboard", "Travel & Budget", "Training", "Claims", "Approvals", "Reports", "Finance", "Credit Cards", "Administration"];
export const PERMISSION_ACTIONS = ["View", "Create", "Edit", "Delete", "Approve", "Export"];

export const buildPreset = (role) => Object.fromEntries(PERMISSION_MODULES.map((module) => [module, Object.fromEntries(PERMISSION_ACTIONS.map((action, index) => [action, role === "Head of Department" ? [0, 1, 2, 4, 5].includes(index) : role === "Head of Unit" ? [0, 1, 2, 4].includes(index) : index === 0]))]));

export const loadPermissionSets = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(PERMISSIONS_STORAGE_KEY));
    return stored && typeof stored === "object" ? stored : {};
  } catch (error) {
    return {};
  }
};

export const savePermissionSets = (sets) => localStorage.setItem(PERMISSIONS_STORAGE_KEY, JSON.stringify(sets));
